// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"42eb0b8c","442":"9910f076"}[chunkId] + ".chunk.js";
};